import AdminLayout from '../../layout/AdminLayout';

import * as Server from 'assets/js/Server';
import { useEffect, useState } from 'react';

export default function RecommendCurrent(){

  const [shopifyCustomerList, setShopifyCustomerList] = useState([]);

  const getShopifyCustomerList = () => {
    Server.sendGet('shopify/customer', {}, getShopifyCustomerListCallback).then();
  }

  const getShopifyCustomerListCallback = res => {
    setShopifyCustomerList(res['resultList']);
  }

  useEffect(() => {
    getShopifyCustomerList();
  }, []);

  return (
    <AdminLayout>
      <div className='title'>
        <div className='tit-head'>
          <i />
          <h4>Customer info</h4>
        </div>
      </div>
      <div className="content">
        <table className="admin-table">
          <thead>
          <tr>
            <th>Customer ID</th>
            <th>Referral ID</th>
            <th>Customer Name</th>
            <th>Customer Email</th>
            <th>Customer Mobile</th>
          </tr>
          </thead>
          <tbody>
          {shopifyCustomerList?.map((item, idx) => (
            <>
              <tr key={idx}>
                <td>{item.customerId}</td>
                <td>{item.referralId}</td>
                <td>{item.customerName}</td>
                <td>{item.customerEmail}</td>
                <td>{item.customerPhone}</td>
              </tr>
            </>
          ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  )
}
